import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import { getOneMonthLater } from 'utilities/helper/getOneMonthLater'

export default function useSetLoans() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const [createdLoans, setCreatedLoans] = useState<Array<IAddBoxLoan>>([])
    useEffect(() => {
        if (store.loans.length > 0) {
            const newLoans: Array<IAddBoxLoan> = []
            store.loans.map((item) => {
                const newItem: IAddBoxLoan = {
                    number_of_repayments: Number(item.number),
                    repayment_interval: 'mnt',
                    number_of_repaid_installments: Number(
                        item.repayment_amount
                    ),
                    interest_rate:
                        item.selectedFeeType === 'percentage'
                            ? Number(item.fee)
                            : 0,
                    is_not_interest_rate:
                        item.selectedFeeType === 'percentage' ? false : true,
                    increase_amount:
                        item.selectedFeeType === 'percentage'
                            ? 0
                            : Number(item.fee),
                    interest_pay_mode: item.feeType,
                    pay_date: item.date ? item.date : getOneMonthLater(),
                    cashout: {
                        amount: Number(item.amount),
                        tag: item.tag ? item.tag : '',
                    },
                }
                newLoans.push(newItem)
            })
            setCreatedLoans(newLoans)
        }
    }, [store])
    return { createdLoans }
}
